import { Redirect, useRouteMatch } from 'react-router'
import { useMemo } from 'react'
import { addActionLog } from '../../../utils/monitoring'

export const RedirectProjectPlanLL = () => {
  const match = useRouteMatch<{ code: string | undefined }>()
  const to = useMemo(() => {
    const code = match.params.code
    if (code) return `/projectPlan/${code}`
    return 'projectPlan'
  }, [match])
  // FIXME To decide whether or not to need redirect code.
  addActionLog('RedirectProjectPlanLL', {})

  return <Redirect to={to} />
}

export const RedirectRefinementSingleSheet = () => {
  const match = useRouteMatch<{ code: string | undefined }>()
  const to = useMemo(() => {
    const code = match.params.code
    if (code) return `/wbsItem/${code}`
    return 'wbsItem'
  }, [match])
  // FIXME To decide whether or not to need redirect code.
  addActionLog('RedirectRefinementSingleSheet', {})

  return <Redirect to={to} />
}

export const RedirectRiskSingleSheet = () => {
  const match = useRouteMatch<{ code: string | undefined }>()
  const to = useMemo(() => {
    const code = match.params.code
    if (code) return `/wbsItem/${code}`
    return 'wbsItem'
  }, [match])
  // FIXME To decide whether or not to need redirect code.
  addActionLog('RedirectRiskSingleSheet', {})

  return <Redirect to={to} />
}

export const RedirectOldRefinements = () => {
  const match = useRouteMatch<{ code: string | undefined }>()
  const to = useMemo(() => {
    const code = match.params.code
    if (code) return `/tickets/${code}?ticketType=REFINEMENT`
    return 'tickets'
  }, [match])
  // FIXME To decide whether or not to need redirect code.
  addActionLog('RedirectOldRefinements', {})

  return <Redirect to={to} />
}
export const RedirectOldRisks = () => {
  const match = useRouteMatch<{ code: string | undefined }>()
  const to = useMemo(() => {
    const code = match.params.code
    if (code) return `/tickets/${code}?ticketType=RISK`
    return 'tickets'
  }, [match])
  // FIXME To decide whether or not to need redirect code.
  addActionLog('RedirectOldRisks', {})

  return <Redirect to={to} />
}
export const RedirectOldIssues = () => {
  const match = useRouteMatch<{ code: string | undefined }>()
  const to = useMemo(() => {
    const code = match.params.code
    if (code) return `/tickets/${code}?ticketType=ISSUE`
    return 'tickets'
  }, [match])
  // FIXME To decide whether or not to need redirect code.
  addActionLog('RedirectOldIssues', {})

  return <Redirect to={to} />
}
export const RedirectOldChangeRequests = () => {
  const match = useRouteMatch<{ code: string | undefined }>()
  const to = useMemo(() => {
    const code = match.params.code
    if (code) return `/tickets/${code}?ticketType=CHANGE_REQUEST`
    return 'tickets'
  }, [match])
  // FIXME To decide whether or not to need redirect code.
  addActionLog('RedirectOldChangeRequests', {})

  return <Redirect to={to} />
}
export const RedirectOldMeetings = () => {
  const match = useRouteMatch<{ code: string | undefined }>()
  const to = useMemo(() => {
    const code = match.params.code
    if (code) return `/tickets/${code}?ticketType=MEETING`
    return 'tickets'
  }, [match])
  // FIXME To decide whether or not to need redirect code.
  addActionLog('RedirectOldMeetings', {})

  return <Redirect to={to} />
}
